// src/pages/LifeAI.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import AIChat from "../components/AIChat";
import { theme } from "../utils/theme";

const C = theme.colors;

export default function LifeAI() {
  const navigate = useNavigate();

  return (
    <div style={{ 
      minHeight: "100vh", 
      background: C.bg, 
      fontFamily: "'DM Sans', sans-serif",
      display: "flex",
      flexDirection: "column"
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700;800&display=swap');
        .fade { animation: fadeIn 0.5s ease-in; }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
      `}</style>

      {/* Top Header with Login Link */}
      <div style={{ 
        padding: "16px 40px", 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        background: C.surface,
        borderBottom: `1px solid ${C.border}`
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: C.text, letterSpacing: -0.5 }}>
            LIFE AI <span style={{ color: C.accent }}>ASSISTANT</span>
          </div>
        </div>
        
        <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
          <button 
            onClick={() => navigate("/kiosk")}
            style={{ 
              background: "none", 
              border: "none", 
              color: C.accent, 
              fontSize: 13, 
              fontWeight: 700, 
              cursor: "pointer",
              letterSpacing: 0.5
            }}
          >
            LOGIN
          </button>
        </div>
      </div>

      {/* Main Content Area */}
      <div style={{ flex: 1, padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
        <div style={{ width: "100%", maxWidth: 800, textAlign: "center", marginBottom: 10 }}>
          <h2 style={{ fontSize: 18, fontWeight: 800, color: C.text, marginBottom: 2 }}>How can I help you today?</h2>
          <p style={{ fontSize: 12, color: C.muted }}>Get instant information about courses, wellness, and institute updates.</p>
        </div>

        <div style={{ width: "100%", maxWidth: 800, height: "calc(100vh - 270px)" }}>
           <AIChat isPublic={true} />
        </div>
      </div>

      {/* Footer */}
      <div style={{ padding: "16px", textAlign: "center", opacity: 0.5 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: C.text }}>© 2026 PANKAJ COMPUTERS LIFEWELLNESS</div>
        <div style={{ fontSize: 10, marginTop: 2, color: C.muted }}>Regracing the Life</div>
      </div>
    </div>
  );
}
